<template>
    <div class="contentblock contentblock--buy-energy" v-if="model" :class="{ 'contentblock--buy-energy-single-product' : ProductCount == 1, 'contentblock--buy-energy-single-product-promo' : activeProduct.isPromoActive && ProductCount == 1 }">
        <section class="contentblock__content">
            <div class="buy-energy-header" :class="{ 'buy-energy-header--in-content' : mode=='content' }">
                <span class="buy-energy-header__title" v-if="ProductCount > 1">{{strings['BuyEnergy.HeaderTitle']}}</span>

                <div class="buy-energy-header__products">
                    <!-- Heizoel tab -->
                    <div v-if="model.heizoel && model.heizoel.isEnabled && ProductCount > 1"
                         class="buy-energy-header__product-tab"
                         :class="{ 'buy-energy-header__product-tab--active' : activeProduct==model.heizoel }"
                         @click="selectProduct(model.heizoel);trackSelectedItem()">
                        <div class="buy-energy-header__product-tab__logo">
                            <div class="buy-energy-header__product-tab__logo__product">
                                <svg class="buy-energy-header__product-tab__logo__product__icon" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg">
                                    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
                                        <circle stroke="currentColor" cx="28" cy="28" r="28" />
                                        <g transform="translate(10.5 10)">
                                            <path d="M3.8 23.2h4.8v-5.7H3.8v5.7Zm10.6-7.3c2.3-2.3 5.3-3.9 8.1-5.4l1.6-.8L14.5 0 7.6 6.9V4.5H3.8v6.2L0 14.6V31h11c-.7-2.3-.9-4-.9-5.1 0-4 1.4-7.2 4.3-10Z" fill="currentColor" />
                                            <path d="M32.3 6.7c-.1-.2-.3-.3-.6-.3-.1 0-.3 0-.4.2-1.5 2.4-4.5 4-7.7 5.8C18.2 15.2 12 18.4 12 26a21 21 0 0 0 2.6 8.8l.3.2.3-.3-.2-.6c-.1-.9-.4-2.4-.4-4 0-4 1.3-7 4-9.3a19 19 0 0 1 7.7-3.6c-2.3 1.2-8.7 5-8.7 12.3 0 2.6.9 6.4 2.2 6.4 1.1 0 4.9-.4 8.3-2.5 4.4-2.7 6.8-7.2 6.8-13 0-4.8-1.7-10.6-2.7-13.7" fill="currentColor" />
                                        </g>
                                    </g>
                                </svg>
                                <svg v-if="model.heizoel.isPromoActive" class="buy-energy-header__product-tab__logo__product__promo-icon" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none" fill-rule="evenodd">
                                        <path fill="currentColor" d="m28 52.7-5.5 2.8-3.9-4.7-6.2.5-1.8-5.9-5.9-1.8.5-6.2-4.7-3.9L3.3 28 .5 22.5l4.7-3.9-.5-6.2 5.9-1.8 1.8-5.9 6.2.5L22.5.5 28 3.3 33.5.5l3.9 4.7 6.2-.5 1.8 5.9 5.9 1.8-.5 6.2 4.7 3.9-2.8 5.5 2.8 5.5-4.7 3.9.5 6.2-5.9 1.8-1.8 5.9-6.2-.5-3.9 4.7z" />
                                        <path d="M37 41.4c-1.5 0-2.8-.5-3.9-1.4-1-.9-1.5-2.1-1.5-3.8v-3.7c0-1.7.5-3 1.5-3.8 1-1 2.4-1.4 4-1.4 1.5 0 2.9.4 3.9 1.3 1 1 1.5 2.2 1.5 3.9v3.7c0 1.6-.5 3-1.5 3.8-1 1-2.4 1.4-4 1.4ZM24 41h-3.8l12.7-26.9h3.9L24 41.2Zm-4.1-13c-1.6 0-3-.4-4-1.3-1-1-1.5-2.2-1.5-3.9v-3.7c0-1.6.5-2.9 1.6-3.8 1-1 2.3-1.4 3.9-1.4s2.9.5 4 1.4c1 .8 1.5 2.1 1.5 3.8v3.7c0 1.7-.6 3-1.6 3.8-1 1-2.3 1.4-4 1.4Zm19 4.5c0-1.4-.6-2.1-1.8-2.1-1.3 0-2 .7-2 2.1V36c0 1.5.7 2.2 2 2.2 1.2 0 1.9-.7 1.9-2.2v-3.4ZM22 19.3c0-1.4-.7-2.1-2-2.1s-2 .7-2 2.1v3.5c0 1.4.7 2.1 2 2.1s2-.7 2-2.1v-3.5Z" fill="#FFF" fill-rule="nonzero" />
                                    </g>
                                </svg>
                            </div>
                            <span class="buy-energy-header__product-tab__name">{{strings['BuyEnergy.Heizoel.TabTitle']}}</span>
                        </div>
                    </div>
                    <!-- Diesel tab -->
                    <div v-if="model.diesel && model.diesel.isEnabled && ProductCount > 1"
                         class="buy-energy-header__product-tab"
                         :class="{ 'buy-energy-header__product-tab--active' : activeProduct==model.diesel }"
                         @click="selectProduct(model.diesel);trackSelectedItem()">
                        <div class="buy-energy-header__product-tab__logo">
                            <div class="buy-energy-header__product-tab__logo__product">
                                <svg class="buy-energy-header__product-tab__logo__product__icon" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg">
                                    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
                                        <circle stroke="currentColor" cx="28" cy="28" r="28" />
                                        <g transform="translate(10 13.5)">
                                            <path d="M7.1 24.3H4.8a.4.4 0 0 1-.4-.4v-1.4c0-.2.2-.4.6-.4h2.2c.1 0 .3.2.3.4v1.4c0 .2-.1.4-.4.4Zm-4.5-12H3V11h-.5v1.3Zm10 2H4.4v-7h14a51.5 51.5 0 0 1 8.2-4.7l-.7-2a1 1 0 0 0-.8-.6H5.7c-.3 0-.7.2-.8.6L3.2 6.5V10.3h-.6v-.5c0-.3-.3-.6-.6-.6H.6c-.3 0-.6.3-.6.6v4c0 .3.3.6.6.6H2c.3 0 .6-.3.6-.7v-.5H3v6.4c0 .4.3.7.7.8-.4.1-.7.5-.7.9v3.6c0 .5.4.9 1 .9h.1v1.8c0 .8.7 1.5 1.5 1.5h2c.8 0 1.5-.7 1.5-1.5v-1.8h4c-1.2-3.1-1.4-5.5-1.4-6.7 0-1.7.3-3.3.8-4.7Z" fill="currentColor" />
                                        </g>
                                        <g transform="translate(23.9 13.7)">
                                            <path d="M19.5.4c-.1-.3-.3-.4-.5-.4s-.4.1-.5.3C17.1 2.6 14.2 4 11 5.8 6 8.5 0 11.7 0 19c0 3.4 1.8 7.1 2.5 8.5l.2.2c.2 0 .3-.1.3-.3v-.6c-.3-.8-.6-2.3-.6-3.9 0-3.7 1.3-6.8 3.9-9 1.8-1.5 4.3-2.6 7.5-3.5-2.3 1.2-8.5 5-8.5 12 0 2.5 1 6.2 2.2 6.2 1 0 4.7-.5 8-2.5 4.3-2.6 6.6-7 6.6-12.6C22.1 9 20.4 3.3 19.5.4" fill="currentColor" />
                                        </g>
                                    </g>
                                </svg>
                                <svg v-if="model.diesel.isPromoActive" class="buy-energy-header__product-tab__logo__product__promo-icon" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none" fill-rule="evenodd">
                                        <path fill="currentColor" d="m28 52.7-5.5 2.8-3.9-4.7-6.2.5-1.8-5.9-5.9-1.8.5-6.2-4.7-3.9L3.3 28 .5 22.5l4.7-3.9-.5-6.2 5.9-1.8 1.8-5.9 6.2.5L22.5.5 28 3.3 33.5.5l3.9 4.7 6.2-.5 1.8 5.9 5.9 1.8-.5 6.2 4.7 3.9-2.8 5.5 2.8 5.5-4.7 3.9.5 6.2-5.9 1.8-1.8 5.9-6.2-.5-3.9 4.7z" />
                                        <path d="M37 41.4c-1.5 0-2.8-.5-3.9-1.4-1-.9-1.5-2.1-1.5-3.8v-3.7c0-1.7.5-3 1.5-3.8 1-1 2.4-1.4 4-1.4 1.5 0 2.9.4 3.9 1.3 1 1 1.5 2.2 1.5 3.9v3.7c0 1.6-.5 3-1.5 3.8-1 1-2.4 1.4-4 1.4ZM24 41h-3.8l12.7-26.9h3.9L24 41.2Zm-4.1-13c-1.6 0-3-.4-4-1.3-1-1-1.5-2.2-1.5-3.9v-3.7c0-1.6.5-2.9 1.6-3.8 1-1 2.3-1.4 3.9-1.4s2.9.5 4 1.4c1 .8 1.5 2.1 1.5 3.8v3.7c0 1.7-.6 3-1.6 3.8-1 1-2.3 1.4-4 1.4Zm19 4.5c0-1.4-.6-2.1-1.8-2.1-1.3 0-2 .7-2 2.1V36c0 1.5.7 2.2 2 2.2 1.2 0 1.9-.7 1.9-2.2v-3.4ZM22 19.3c0-1.4-.7-2.1-2-2.1s-2 .7-2 2.1v3.5c0 1.4.7 2.1 2 2.1s2-.7 2-2.1v-3.5Z" fill="#FFF" fill-rule="nonzero" />
                                    </g>
                                </svg>
                            </div>
                            <span class="buy-energy-header__product-tab__name">{{strings['BuyEnergy.Diesel.TabTitle']}}</span>
                        </div>
                    </div>
                    <!-- Pellets tab -->
                    <div v-if="model.pellets && model.pellets.isEnabled && ProductCount > 1"
                         class="buy-energy-header__product-tab"
                         :class="{ 'buy-energy-header__product-tab--active' : activeProduct==model.pellets }"
                         @click="selectProduct(model.pellets);trackSelectedItem()">
                        <div class="buy-energy-header__product-tab__logo">
                            <div class="buy-energy-header__product-tab__logo__product">
                                <svg class="buy-energy-header__product-tab__logo__product__icon" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg">
                                    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
                                        <circle stroke="currentColor" cx="28" cy="28" r="28" />
                                        <g transform="translate(9.5 12.5)">
                                            <path d="M3.3 20h4.1v-5h-4v5Zm7.6 2.3c-.8-1.2-1-2.7-.6-4.1a4.8 4.8 0 0 1 6-3.2h.2l-.1-.4a4.5 4.5 0 0 1 5-5.9L12.5 0l-6 6V4H3.3v5.3L0 12.7V27h8.2a4.7 4.7 0 0 1 2.4-4.5l.3-.2ZM34.8 22.4l-4-1.2-3.1 1.7 1.3 4.4 3.9 1.2a3.1 3.1 0 0 0 4-2c.5-1.7-.5-3.5-2.1-4M27 23.3l-5.3 2.8.7 2.4a3 3 0 1 0 5.6-1.7l-1-3.5Z" fill="currentColor" />
                                            <path d="M12 18.6c-.4 1.3 0 2.7 1.1 3.5l5.6-3-.5-2-2.3-.6c-1.6-.5-3.4.4-4 2M20 10.4a3 3 0 0 0-2 3.7l1.5 4.6 5.3-2.8-1-3.5a3 3 0 0 0-3.7-2M33.7 17.8a3 3 0 0 0-2.9-3.8l-1.2.3-18 9.6a3 3 0 0 0 1.5 5.6c.3 0 .8-.2 1.1-.4l18.3-9.7c.6-.3 1-1 1.2-1.6" fill="currentColor" />
                                        </g>
                                    </g>
                                </svg>
                                <svg v-if="model.pellets.isPromoActive" class="buy-energy-header__product-tab__logo__product__promo-icon" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none" fill-rule="evenodd">
                                        <path fill="currentColor" d="m28 52.7-5.5 2.8-3.9-4.7-6.2.5-1.8-5.9-5.9-1.8.5-6.2-4.7-3.9L3.3 28 .5 22.5l4.7-3.9-.5-6.2 5.9-1.8 1.8-5.9 6.2.5L22.5.5 28 3.3 33.5.5l3.9 4.7 6.2-.5 1.8 5.9 5.9 1.8-.5 6.2 4.7 3.9-2.8 5.5 2.8 5.5-4.7 3.9.5 6.2-5.9 1.8-1.8 5.9-6.2-.5-3.9 4.7z" />
                                        <path d="M37 41.4c-1.5 0-2.8-.5-3.9-1.4-1-.9-1.5-2.1-1.5-3.8v-3.7c0-1.7.5-3 1.5-3.8 1-1 2.4-1.4 4-1.4 1.5 0 2.9.4 3.9 1.3 1 1 1.5 2.2 1.5 3.9v3.7c0 1.6-.5 3-1.5 3.8-1 1-2.4 1.4-4 1.4ZM24 41h-3.8l12.7-26.9h3.9L24 41.2Zm-4.1-13c-1.6 0-3-.4-4-1.3-1-1-1.5-2.2-1.5-3.9v-3.7c0-1.6.5-2.9 1.6-3.8 1-1 2.3-1.4 3.9-1.4s2.9.5 4 1.4c1 .8 1.5 2.1 1.5 3.8v3.7c0 1.7-.6 3-1.6 3.8-1 1-2.3 1.4-4 1.4Zm19 4.5c0-1.4-.6-2.1-1.8-2.1-1.3 0-2 .7-2 2.1V36c0 1.5.7 2.2 2 2.2 1.2 0 1.9-.7 1.9-2.2v-3.4ZM22 19.3c0-1.4-.7-2.1-2-2.1s-2 .7-2 2.1v3.5c0 1.4.7 2.1 2 2.1s2-.7 2-2.1v-3.5Z" fill="#FFF" fill-rule="nonzero" />
                                    </g>
                                </svg>
                            </div>
                            <span class="buy-energy-header__product-tab__name">{{strings['BuyEnergy.Pellets.TabTitle']}}</span>
                        </div>
                    </div>
                    <!-- Tankrevision tab -->
                    <div v-if="model.tankrevision && model.tankrevision.isEnabled && ProductCount > 1"
                         class="buy-energy-header__product-tab"
                         :class="{ 'buy-energy-header__product-tab--active' : activeProduct==model.tankrevision }"
                         @click="selectProduct(model.tankrevision);trackSelectedItem()">
                        <div class="buy-energy-header__product-tab__logo">
                            <div class="buy-energy-header__product-tab__logo__product">
                                <svg class="buy-energy-header__product-tab__logo__product__icon" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg">
                                    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
                                        <circle stroke="currentColor" cx="28" cy="28" r="28" />
                                        <g transform="translate(10 13)">
                                            <g transform="translate(10.7 12.6)">
                                                <path d="M6.6 0a7 7 0 0 0 0 14V0Zm.9 14.1h10.4V0H7.5v14.1ZM18.7.1v14a7 7 0 0 0 0-14Zm-.8 15.8v.9c0 .2.2.4.4.4h2.9c.2 0 .4-.2.4-.4v-1.4c-.9.3-1.9.5-2.9.5h-.8ZM6.7 16h.8v.9c0 .2-.2.4-.4.4H4.2a.5.5 0 0 1-.4-.4v-1.4c.9.3 1.9.5 3 .5Z" fill="currentColor" />
                                            </g>
                                            <path d="M3.3 20h4v-5h-4v5ZM21.6 9.2l-.9-.9L12.5 0l-.6.6-5.3 5.3V4H3.3v5.3L0 12.6v14.1h12.4a8.8 8.8 0 0 1 5.3-15.9h5.5l-1.6-1.6Z" fill="currentColor" />
                                        </g>
                                    </g>
                                </svg>
                                <svg v-if="model.tankrevision.isPromoActive" class="buy-energy-header__product-tab__logo__product__promo-icon" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none" fill-rule="evenodd">
                                        <path fill="currentColor" d="m28 52.7-5.5 2.8-3.9-4.7-6.2.5-1.8-5.9-5.9-1.8.5-6.2-4.7-3.9L3.3 28 .5 22.5l4.7-3.9-.5-6.2 5.9-1.8 1.8-5.9 6.2.5L22.5.5 28 3.3 33.5.5l3.9 4.7 6.2-.5 1.8 5.9 5.9 1.8-.5 6.2 4.7 3.9-2.8 5.5 2.8 5.5-4.7 3.9.5 6.2-5.9 1.8-1.8 5.9-6.2-.5-3.9 4.7z" />
                                        <path d="M37 41.4c-1.5 0-2.8-.5-3.9-1.4-1-.9-1.5-2.1-1.5-3.8v-3.7c0-1.7.5-3 1.5-3.8 1-1 2.4-1.4 4-1.4 1.5 0 2.9.4 3.9 1.3 1 1 1.5 2.2 1.5 3.9v3.7c0 1.6-.5 3-1.5 3.8-1 1-2.4 1.4-4 1.4ZM24 41h-3.8l12.7-26.9h3.9L24 41.2Zm-4.1-13c-1.6 0-3-.4-4-1.3-1-1-1.5-2.2-1.5-3.9v-3.7c0-1.6.5-2.9 1.6-3.8 1-1 2.3-1.4 3.9-1.4s2.9.5 4 1.4c1 .8 1.5 2.1 1.5 3.8v3.7c0 1.7-.6 3-1.6 3.8-1 1-2.3 1.4-4 1.4Zm19 4.5c0-1.4-.6-2.1-1.8-2.1-1.3 0-2 .7-2 2.1V36c0 1.5.7 2.2 2 2.2 1.2 0 1.9-.7 1.9-2.2v-3.4ZM22 19.3c0-1.4-.7-2.1-2-2.1s-2 .7-2 2.1v3.5c0 1.4.7 2.1 2 2.1s2-.7 2-2.1v-3.5Z" fill="#FFF" fill-rule="nonzero" />
                                    </g>
                                </svg>
                            </div>
                            <span class="buy-energy-header__product-tab__name">{{strings['BuyEnergy.Tankrevision.TabTitle']}}</span>
                        </div>
                    </div>
                    <!-- Boilerentkalkung tab -->
                    <div v-if="model.boiler && model.boiler.isEnabled && ProductCount > 1"
                         class="buy-energy-header__product-tab"
                         :class="{ 'buy-energy-header__product-tab--active' : activeProduct==model.boiler }"
                         @click="selectProduct(model.boiler);trackSelectedItem()">
                        <div class="buy-energy-header__product-tab__logo">
                            <div class="buy-energy-header__product-tab__logo__product">
                                <svg class="buy-energy-header__product-tab__logo__product__icon" viewBox="0 0 58 58" xmlns="http://www.w3.org/2000/svg">
                                    <g transform="translate(1 1)" fill="none" fill-rule="evenodd">
                                        <circle stroke="currentColor" cx="28" cy="28" r="28" />
                                        <path d="M15.9 32.2h4.9v-5.8h-4.9v5.8ZM27.2 22V21l.6-.6c.2-.2 1.5-1.4 4.3-2.1h.1l.2-.1h.4l.1-.1a13 13 0 0 1 .5-.1H34.1l.2-.1H36.1l-9.3-9.4-7 7v-2.4h-3.9v6.4l-3.9 4v16.7H27.2V22Z" fill="currentColor" />
                                        <path d="M37.8 26a2.3 2.3 0 0 0-3-.4 2.3 2.3 0 0 0-.8 2.7l.2.4 1.6-1.6.6.7-1.5 1.6a2.2 2.2 0 0 0 3.4-2 2.2 2.2 0 0 0-.5-1.4Zm1.5 1.5a3.2 3.2 0 1 0-6.5 0 3.2 3.2 0 0 0 6.5 0Zm3.1-5.6v18.3a2.1 2.1 0 0 1-.1.2l-.3.2-.2.1-.2.2h-.1a9 9 0 0 1-2 .8v-1.5h-7.3v1.6a8 8 0 0 1-1.9-.8l-1-.7V21.8s2-2 6.6-2h.2c4.8.1 6.3 2 6.3 2Zm-9.2 19.3v2H38.5v-2h-5.3Zm6.3 3h-7.3v-1.4l-1.9-.7v3.4h11v-3.4l-1.8.6v1.5Zm-4.6-14.8Zm-.7-.7Z" fill="currentColor" />
                                    </g>
                                </svg>
                                <svg v-if="model.boiler.isPromoActive" class="buy-energy-header__product-tab__logo__product__promo-icon" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none" fill-rule="evenodd">
                                        <path fill="currentColor" d="m28 52.7-5.5 2.8-3.9-4.7-6.2.5-1.8-5.9-5.9-1.8.5-6.2-4.7-3.9L3.3 28 .5 22.5l4.7-3.9-.5-6.2 5.9-1.8 1.8-5.9 6.2.5L22.5.5 28 3.3 33.5.5l3.9 4.7 6.2-.5 1.8 5.9 5.9 1.8-.5 6.2 4.7 3.9-2.8 5.5 2.8 5.5-4.7 3.9.5 6.2-5.9 1.8-1.8 5.9-6.2-.5-3.9 4.7z" />
                                        <path d="M37 41.4c-1.5 0-2.8-.5-3.9-1.4-1-.9-1.5-2.1-1.5-3.8v-3.7c0-1.7.5-3 1.5-3.8 1-1 2.4-1.4 4-1.4 1.5 0 2.9.4 3.9 1.3 1 1 1.5 2.2 1.5 3.9v3.7c0 1.6-.5 3-1.5 3.8-1 1-2.4 1.4-4 1.4ZM24 41h-3.8l12.7-26.9h3.9L24 41.2Zm-4.1-13c-1.6 0-3-.4-4-1.3-1-1-1.5-2.2-1.5-3.9v-3.7c0-1.6.5-2.9 1.6-3.8 1-1 2.3-1.4 3.9-1.4s2.9.5 4 1.4c1 .8 1.5 2.1 1.5 3.8v3.7c0 1.7-.6 3-1.6 3.8-1 1-2.3 1.4-4 1.4Zm19 4.5c0-1.4-.6-2.1-1.8-2.1-1.3 0-2 .7-2 2.1V36c0 1.5.7 2.2 2 2.2 1.2 0 1.9-.7 1.9-2.2v-3.4ZM22 19.3c0-1.4-.7-2.1-2-2.1s-2 .7-2 2.1v3.5c0 1.4.7 2.1 2 2.1s2-.7 2-2.1v-3.5Z" fill="#FFF" fill-rule="nonzero" />
                                    </g>
                                </svg>
                            </div>
                            <span class="buy-energy-header__product-tab__name">{{strings['BuyEnergy.Boiler.TabTitle']}}</span>
                        </div>
                    </div>

                    <!-- Product Details -->
                    <div v-if="activeProduct" class="buy-energy-header__product-details"
                         :class="[ProductDetailsSizeClass, ProductDetailsPositionClass, { 'buy-energy-header__product-details--promo' : activeProduct.isPromoActive, 'buy-energy-header__product-details--single-product' : ProductCount == 1 }]">
                        <div class="buy-energy-header__product-details__order">
                            <div class="buy-energy-header__product-details__title">{{strings[activeProduct.stringKeyOrderTitle]}}</div>
                            <div class="buy-energy-header__product-details__desc">{{strings[activeProduct.stringKeyOrderText]}}</div>
                            <PriceForm v-if="ProductHasOrderForm"
                                       :action="activeProduct.shopUrl"
                                       :coupon="activeProduct.promoCoupon"
                                       :product="activeProduct.productNameTracking"
                                       :zipCityLabel="strings['BuyEnergy.ZipCode']"
                                       :amountLabel="strings[activeProduct.stringKeyUnit]"
                                       :units="strings[activeProduct.stringKeyUnit]"
                                       :buttontext="strings['BuyEnergy.OfferLinkText']" />
                            <a v-if="!ProductHasOrderForm" :href="DirectLinkShopUrl" class="buy-energy-header__link-button" :data-product="activeProduct.productNameTracking" @click="trackSnAClick()">{{strings['BuyEnergy.OfferLinkText']}}</a>
                        </div>
                        <div class="buy-energy-header__product-details__teaser" v-if="activeProduct.showTeaser">
                            <div class="buy-energy-header__product-details__title">
                                {{activeProduct.teaserTitle}}
                                <svg class="buy-energy-header__product-details__title__promo-icon" v-if="activeProduct.isPromoActive" viewBox="0 0 56 56" xmlns="http://www.w3.org/2000/svg">
                                    <g fill="none" fill-rule="evenodd">
                                        <path fill="currentColor" d="m28 52.7-5.5 2.8-3.9-4.7-6.2.5-1.8-5.9-5.9-1.8.5-6.2-4.7-3.9L3.3 28 .5 22.5l4.7-3.9-.5-6.2 5.9-1.8 1.8-5.9 6.2.5L22.5.5 28 3.3 33.5.5l3.9 4.7 6.2-.5 1.8 5.9 5.9 1.8-.5 6.2 4.7 3.9-2.8 5.5 2.8 5.5-4.7 3.9.5 6.2-5.9 1.8-1.8 5.9-6.2-.5-3.9 4.7z" />
                                        <path d="M37 41.4c-1.5 0-2.8-.5-3.9-1.4-1-.9-1.5-2.1-1.5-3.8v-3.7c0-1.7.5-3 1.5-3.8 1-1 2.4-1.4 4-1.4 1.5 0 2.9.4 3.9 1.3 1 1 1.5 2.2 1.5 3.9v3.7c0 1.6-.5 3-1.5 3.8-1 1-2.4 1.4-4 1.4ZM24 41h-3.8l12.7-26.9h3.9L24 41.2Zm-4.1-13c-1.6 0-3-.4-4-1.3-1-1-1.5-2.2-1.5-3.9v-3.7c0-1.6.5-2.9 1.6-3.8 1-1 2.3-1.4 3.9-1.4s2.9.5 4 1.4c1 .8 1.5 2.1 1.5 3.8v3.7c0 1.7-.6 3-1.6 3.8-1 1-2.3 1.4-4 1.4Zm19 4.5c0-1.4-.6-2.1-1.8-2.1-1.3 0-2 .7-2 2.1V36c0 1.5.7 2.2 2 2.2 1.2 0 1.9-.7 1.9-2.2v-3.4ZM22 19.3c0-1.4-.7-2.1-2-2.1s-2 .7-2 2.1v3.5c0 1.4.7 2.1 2 2.1s2-.7 2-2.1v-3.5Z" fill="#A4091E" fill-rule="nonzero" />
                                    </g>
                                </svg>
                            </div>
                            <div class="buy-energy-header__product-details__teaser__content migrol-rt-content" v-html="activeProduct.teaserContentHtml"></div>
                        </div>
                    </div>
                </div>

            </div>
        </section>
    </div>
</template>

<script>
    import PriceForm from './PriceForm'

    export default {
        props: {
            modeljson: String,
            stringsjson: String,
            mode: {
                type: String,
                default: 'header',
                required: false
            },
        },
        data() {
            return {
                model: null,
                activeProduct: null,
                strings: []
            }
        },
        computed: {
            ProductHasOrderForm() {
                return this.activeProduct && this.activeProduct.hasOrderForm;
            },
            ProductCount() {
                if (this.model) {
                    let count = 0;
                    if (this.model.heizoel.isEnabled) {
                        count++;
                    } if (this.model.diesel.isEnabled) {
                        count++;
                    } if (this.model.pellets.isEnabled) {
                        count++;
                    } if (this.model.tankrevision.isEnabled) {
                        count++;
                    } if (this.model.boiler.isEnabled) {
                        count++;
                    }
                    return count;
                }
                return 0;
            },
            ProductDetailsSizeClass() {
                if (this.model) {
                    return "buy-energy-header__product-details--size" + this.ProductCount;
                }
                return "";
            },
            ActiveProductPosition() {
                let pos = 0;
                if (this.model) {
                    if (this.model.heizoel.isEnabled) {
                        pos++;
                        if (this.activeProduct == this.model.heizoel) {
                            return pos;
                        }
                    } if (this.model.diesel.isEnabled) {
                        pos++;
                        if (this.activeProduct == this.model.diesel) {
                            return pos;
                        }
                    } if (this.model.pellets.isEnabled) {
                        pos++;
                        if (this.activeProduct == this.model.pellets) {
                            return pos;
                        }
                    } if (this.model.tankrevision.isEnabled) {
                        pos++;
                        if (this.activeProduct == this.model.tankrevision) {
                            return pos;
                        }
                    } if (this.model.boiler.isEnabled) {
                        pos++;
                        if (this.activeProduct == this.model.boiler) {
                            return pos;
                        }
                    }
                }
                return "";
            },
            ProductDetailsPositionClass() {
                let position = this.ActiveProductPosition;
                if (position > 0) {
                    return "buy-energy-header__product-details--pos" + position;
                }
                return "";
            },
            DirectLinkShopUrl() {
                let url = this.activeProduct.shopUrl;
                if (this.activeProduct.isPromoActive) {
                    url += "?c=" + this.activeProduct.promoCoupon;
                }
                return url;
            }
        },
        methods: {
            selectProduct(selectedProduct) {
                this.activeProduct = selectedProduct;
            },
            trackSelectedItem() {
                if (window.dataLayer) {
                    window.dataLayer.push({
                        event: 'select_item',
                        ecommerce: {
                            items: [{
                                item_name: this.activeProduct.productNameTracking, // Produktname in Shopsprache - Heiz�l, Holzpellets, Diesel
                                item_brand: 'migrol', // Brand des Produktes - falls nicht vorhanden 'migrol'
                                item_category: this.activeProduct.productNameTracking, // z.B.: Heiz�l, Holzpellets, Diesel
                                index: this.ActiveProductPosition // Position der Produkt auf der Seite (1, 2, 3)
                            }]
                        }
                    });
                }
            },
            trackItemViews() {
                if (window.dataLayer) {
                    let viewedItems = [];
                    let pos = 0;
                    if (this.model) {
                        if (this.model.heizoel.isEnabled) {
                            pos++;
                            viewedItems.push({
                                item_name: this.model.heizoel.productNameTracking,
                                item_brand: 'migrol',
                                item_category: this.model.heizoel.productNameTracking,
                                index: pos
                            });
                        } if (this.model.diesel.isEnabled) {
                            pos++;
                            viewedItems.push({
                                item_name: this.model.diesel.productNameTracking,
                                item_brand: 'migrol',
                                item_category: this.model.diesel.productNameTracking,
                                index: pos
                            });
                        } if (this.model.pellets.isEnabled) {
                            pos++;
                            viewedItems.push({
                                item_name: this.model.pellets.productNameTracking,
                                item_brand: 'migrol',
                                item_category: this.model.pellets.productNameTracking,
                                index: pos
                            });
                        } if (this.model.tankrevision.isEnabled) {
                            pos++;
                            viewedItems.push({
                                item_name: this.model.tankrevision.productNameTracking,
                                item_brand: 'migrol',
                                item_category: this.model.tankrevision.productNameTracking,
                                index: pos
                            });
                        } if (this.model.boiler.isEnabled) {
                            pos++;
                            viewedItems.push({
                                item_name: this.model.boiler.productNameTracking,
                                item_brand: 'migrol',
                                item_category: this.model.boiler.productNameTracking,
                                index: pos
                            });
                        }

                        window.dataLayer.push({
                            event: 'view_item_list',
                            ecommerce: {
                                items: viewedItems
                            }
                        });
                    }
                }
            },
            trackSnAClick() {
                if (window.dataLayer) {
                    window.dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object. (WWW-2077)
                    window.dataLayer.push({
                        event: 'add_to_cart',
                        ecommerce: {
                            items: [{
                                item_name: this.activeProduct.productNameTracking, // Produktname in Shopsprache - Heiz�l, Holzpellets, Diesel
                                item_brand: 'migrol', // Brand des Produktes - falls nicht vorhanden 'migrol'
                                item_category: this.activeProduct.productNameTracking, // z.B.: Heiz�l, Holzpellets, Diesel
                                quantity: null // Menge
                            }]
                        }
                    });
                }
            }
        },
        mounted() {
            //decode model:
            var textArea = document.createElement('textarea');
            textArea.innerHTML = this.modeljson;
            this.model = JSON.parse(textArea.value);
            //console.log("model:", this.model);

            //decode strings:
            textArea.innerHTML = this.stringsjson;
            this.strings = JSON.parse(textArea.value);
            //console.log("strings:",this.strings);

            //select default product:
            if (this.model.heizoel.isEnabled) {
                this.selectProduct(this.model.heizoel);
            } else if (this.model.diesel.isEnabled) {
                this.selectProduct(this.model.diesel);
            } else if (this.model.pellets.isEnabled) {
                this.selectProduct(this.model.pellets);
            } else if (this.model.tankrevision.isEnabled) {
                this.selectProduct(this.model.tankrevision);
            } else if (this.model.boiler.isEnabled) {
                this.selectProduct(this.model.boiler);
            }

            //tracking:
            this.trackItemViews();
        },
        components: {
            PriceForm
        }
    };
</script>